/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import clsx from 'clsx'
import {Modal} from 'react-bootstrap'
import {KTIcon} from '../../../_metronic/helpers'
type Props = {
  text: string
  fileBase64: string
  modalTitle?: string
  modalBackButtonText?: string
  touched?: boolean
  errors?: string
  props?: any
}

const TermChecker: React.FC<Props> = ({
  text,
  fileBase64,
  modalTitle,
  modalBackButtonText,
  touched,
  errors,
  props,
}) => {
  const [show, setShow] = useState(false)
  return (
    <>
      <div className='fv-row mb-8'>
        <label className='form-check form-check-inline' htmlFor='kt_login_toc_agree'>
          <input className='form-check-input' type='checkbox' id='kt_login_toc_agree' {...props} />
          <span>
            <a
              className='ms-1 link-primary'
              onClick={() => {
                setShow(true)
              }}
            >
              {text}
            </a>
          </span>
        </label>
        {touched && errors && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{errors}</span>
            </div>
          </div>
        )}
      </div>
      <Modal className='modal fade' tabIndex={-1} show={show} size='xl' aria-hidden='true' centered>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>{modalTitle}</h5>

            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              onClick={() => {
                setShow(false)
              }}
            >
              <KTIcon iconName='cross' className='fs-2x' />
            </div>
          </div>
          <div className='modal-body'>
            <iframe src={fileBase64} height='500vh' width='100%'></iframe>
          </div>
        </div>
      </Modal>
    </>
  )
}

export {TermChecker}
